export default `<div class="dropdown-content-container">
    <div class="dropdown-content hidden">
        <slot></slot>
    </div>
    <div
        class="dropdown-content-live-region sr-only"
        aria-live="polite"
        aria-atomic="true"
    ></div>
</div>

<style>
    .hidden {
        display: none;
    }

    .dropdown-content {
        background-color: var(--svea-dropdown-background, #ffffff);
        border: 1px solid var(--svea-dropdown-border, #949494);
        border-radius: var(--svea-dropdown-border-radius, 0.75rem);
        overflow: hidden;
        box-shadow:
            0px 5px 12px 0px #0000001f,
            0px 0px 1px 0px #00000047;
    }

    .sr-only {
        clip: rect(0 0 0 0);
        clip-path: inset(100%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }
</style>
`